export default __webpack_public_path__ + "static/media/r.4a163ce2.mp4";